<template>
  <div>
    <div v-if="hasLog">
      <div v-for="(item, idx) in logItems" :key="idx">
        <timeline-item :date="item.date">
          <div class="row w-100">
            <div class="col-12 col-lg-3">
              <label class="color-secondary-6 font-14 font-weight-normal mr-2">
                Estatus:
              </label>
              <custom-balloon
                class="text-nowrap"
                :background-color="item.statusColor"
                :text="item.statusName"
                dot
              />
            </div>
            <div class="col-12 col-lg-3">
              <label class="color-secondary-6 font-14 font-weight-normal mr-2">
                Número de Solicitud:
              </label>
              <p>{{ item.code | empty }}</p>
            </div>
            <div class="col-12 col-lg-3">
              <label class="color-secondary-6 font-14 font-weight-normal mr-2">
                Fecha de Solicitud:
              </label>
              <p>{{ item.requestDate | date }}</p>
            </div>
            <div class="col-12 col-lg-3">
              <label class="color-secondary-6 font-14 font-weight-normal mr-2">
                Realizado Por:
              </label>
              <p>{{ item.submittedBy | empty }}</p>
            </div>
          </div>
          <div class="row w-100">
            <div class="col-12 col-lg-3">
              <label class="color-secondary-6 font-14 font-weight-normal mr-2">
                Fecha de Envío:
              </label>
              <p>{{ item.sendDate | date }}</p>
            </div>
            <div class="col-12 col-lg-3">
              <label class="color-secondary-6 font-14 font-weight-normal mr-2">
                Asignado a:
              </label>
              <p>{{ item.assginedTo | empty }}</p>
            </div>
            <div class="col-12 col-lg-3">
              <label class="color-secondary-6 font-14 font-weight-normal mr-2">
                Fecha de Transferencia:
              </label>
              <p>{{ item.transferDate | date }}</p>
            </div>
          </div>
          <div class="row w-100">
            <div class="col-12 col-lg-3">
              <label class="color-secondary-6 font-14 font-weight-normal mr-2">
                Comentario:
              </label>
              <p>{{ item.comment | empty }}</p>
            </div>
          </div>
        </timeline-item>
      </div>
      <div class="row my-4">
        <div class="col text-center">
          <action-button
            v-if="showMore"
            variant="outline-success custom-view-more actionButton"
            i="fas fa-chevron-down"
            @click="handlerMore"
          >
            Ver más
          </action-button>
        </div>
      </div>
    </div>
    <custom-result-not-found v-else text="No hay Información Disponible." />
  </div>
</template>

<script>
import CustomResultNotFound from "custom-result-not-found";
import ActionButton from "ActionButton";
import TimelineItem from "@quisit/timeline-item";
import CustomBalloon from "custom-balloon";
import inventoryTransferService from "@/services/api/inventoryTransfer.api";
import alertMixin from "@quisit/mipe-utils/mixins/alert.mixin.js";
import SectionTitle from "SectionTitle";

export default {
  name: "BookHistory",
  components: {
    TimelineItem,
    CustomResultNotFound,
    ActionButton,
    CustomBalloon,
    SectionTitle
  },
  mixins: [alertMixin],
  props: {
    transfer: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      history: [],
      logCount: 2
    };
  },
  computed: {
    logItems() {
      const items = this.history
        .map(item => {
          return {
            ...item,
            date: item.createdDate
          };
        })
        .slice(0, this.logCount);
      return items;
    },
    hasLog() {
      return this.history.length > 0;
    },
    showMore() {
      return this.history.length > this.logCount && this.history.length > 2;
    }
  },
  async mounted() {
    await this.getHistory();
  },
  methods: {
    async getHistory() {
      try {
        const { data } = await inventoryTransferService.getTransferHistory(
          this.transfer.id
        );
        this.history = data;
      } catch (error) {
        this.ShowToast("Error", error, "error");
      }
    },
    handlerMore() {
      this.logCount += 2;
    }
  }
};
</script>

<style></style>
